// @flow
import * as React from "react";
import Typography from "@material-ui/core/Typography";
import { useFirestore, useFirestoreDocDataOnce } from "reactfire";
import type { Game } from "../../common/types";
import formatDates from "../../common/formatDates";
import Box from "@material-ui/core/Box";

type Props = {
  game: Game,
};

function ScheduleGameCardResults({ game }: Props) {
  const firestore = useFirestore();
  const gameResult = useFirestoreDocDataOnce(
    firestore
      .collection("sams")
      .doc("matches")
      .collection("mappedMatches")
      .doc(game.id)
  );

  if (gameResult == null || gameResult.setPoints == null) {
    return (
      <Typography
        variant="caption"
        color="textSecondary"
        component="p"
        align="center"
      >
        Ergebnis kommt bald
      </Typography>
    );
  }
  return (
    <>
      <Typography variant="h5" component="p" align="center">
        <b>{gameResult.setPoints}</b>
      </Typography>
      {gameResult.sets != null && gameResult.sets.length > 0 && (
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          align="center"
        >
          {gameResult.sets.join(", ")}
        </Typography>
      )}
      <Box mt={1}>
        <Typography
          variant="caption"
          color="textSecondary"
          component="p"
          align="center"
        >
          {formatDates.prettyPastDate(game.date)}
        </Typography>
      </Box>
    </>
  );
}

export default ScheduleGameCardResults;
